import { Col, Row } from "react-bootstrap";

function OurValues() {
  const valuesItem = [
    {
      title: "Integrity and Transparency",
      description:
        "Openness and the highest standards of corporate and personal ethics in all that we do.",
    },
    {
      title: "Passion to Serve Our Customers",
      description:
        "A strong commitment to anticipate and address customer needs beyond expectation, helping them achieve their objectives.",
    },
    {
      title: "Modesty",
      description:
        "Nurturing imagination and fostering creativity for better results.",
    },
    {
      title: "Innovativeness",
      description:
        "Nurturing imagination and fostering creativity for better results.",
    },
    {
      title: "Meritocracy",
      description:
        "Defining, differentiating, and reinforcing excellence in people.",
    },
    {
      title: "Care for Society",
      description: "Contributing towards a better tomorrow.",
    },
  ];
  return (
    <>
      <style type="text/css">
        {`

          .page{
            margin-top: 80px;
            margin-bottom: 80px;
          }
          .page-title{
            font-size: 45px;
            font-weight: 600;
            line-height: 58.5px;
            letter-spacing: -0.023em;
            text-align: left;
            margin-bottom: 24px;
          }

          .page-subtitle{
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: -0.023em;
            text-align: left;
            margin-bottom: 24px;
          }

          .values-item {
            padding: 16px;
            gap: 4px;
            border-radius: 5px;
            opacity: 0px;
            margin: 12px 15px;
            border: 1px solid #D6D6D6;

          }

          .values-item img{
            width: 40px;
            height: 40px;
            margin: 10px 16px;
          }

          .values-item h1{
            font-size: 18px;
            font-weight: 700;
            line-height: 27px;
            text-align: left;
            color: #000042;
          }

           .values-item p{
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: -0.023em;
            text-align: left;
            color: #667085;
          }

          .stats-item-row {
           gap: 30px;
          }
        `}
      </style>
      <div className="container page">
        <h1 className="page-title">Our Values</h1>
        <Row className="overflow-hidden">
          {valuesItem.map((item, index) => (
            <Col className="values-item" md={3} xs={5}>
              {/* <img alt={`values-item-${index}`} src={ShieldLogo} /> */}
              <h1>{item.title}</h1>
              <p>{item.description}</p>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default OurValues;
